import { atom } from 'jotai';

/**
 * Atom for controlling the global "expand all" state of journal entries.
 * When true, all entries in the timeline will be shown in expanded state.
 * Individual entries can still maintain their own expansion state.
 */
export const allEntriesExpandedAtom = atom<boolean>(false);
